import React from "react";
import { List, Button, Skeleton, Col, Row, Icon } from "antd";
import styled from "styled-components";
import { Invoice } from "../../../lib/model/Invoice";
import { priceString } from "../../../lib/formatters";

const DataLabel = styled.span`
  font-size: 14px;
  font-weight: 400;
  color: #061a32;
`;

const PriceLabel = styled.span`
  font-size: 28px;
  font-weight: 400;
  line-height: 1.21;
  color: #061a32;
`;

const StyledCol1 = styled(Col)`
  border-right: 1px solid #e8e8e8;
  height: 100% !important;;
  padding-right: 30px !important;

  @media only screen and (max-width: 768px) { 
    margin-bottom: 10px !important;
    border: none;
  }
`;

const StyledCol2 = styled(Col)`
  padding: 0px 25px !important;
  height: 100% !important;

  @media only screen and (max-width: 768px) { 
    padding: 0 !important;
  }
`;

type Props = {
  isPlaceholder: boolean;
  invoice?: Invoice;
  onDetailsClick: (invoice: Invoice) => void;
};

export const InvoiceCell: React.FC<Props> = props => {
  const { invoice, isPlaceholder, onDetailsClick } = props;
  return (
    <List.Item style={{ padding: 0 }}>
      <Row
        type="flex"
        style={{
          width: "100%",
          padding: "30px",
          border: "1px solid #e8e8e8",
          marginBottom: 15,
        }}
        justify="center"
        align="middle"
      >
        <Skeleton title={false} loading={isPlaceholder} active>
          {invoice && (
            <>
              <StyledCol1
                span={9}
                xs={24} sm={18} md={9}
              >
                <Row
                  type="flex"
                  align="middle"
                  justify="space-between"
                  style={{ height: "100%" }}
                >
                  <Col span={15}>
                    <DataLabel>Rechnung {invoice.id}</DataLabel>
                  </Col>
                  <Col span={9}>
                    <Button
                      type="primary"
                      style={{
                        borderRadius: 0,
                        height: 33,
                        backgroundColor: "#386ee8",
                        border: "none",
                        boxShadow: "0 3px 6px 0 rgba(0, 0, 0, 0.16)"
                      }}
                      onClick={() => onDetailsClick(invoice)}
                    >
                      Details <Icon type="right" />
                    </Button>
                  </Col>
                </Row>
              </StyledCol1>
              <StyledCol2 span={15} xs={24} sm={18} md={15}>
                <Row type="flex" align="middle" justify="space-between">
                  <Col span={11} xs={8} sm={11} md={11}>
                    <DataLabel>
                      Auftrag {invoice.orders.map(o => o.orderId).join(", ")}
                    </DataLabel>
                  </Col>
                  <Col span={8} xs={11} sm={8} md={8}>
                    <PriceLabel>{priceString(invoice.amount.net)}</PriceLabel>
                  </Col>
                  <Col span={5} xs={5} sm={5} md={5}>
                    <Button
                      type="primary"
                      style={{
                        borderRadius: 0,
                        height: 33,
                        backgroundColor: "#386ee8",
                        border: "none",
                        boxShadow: "0 3px 6px 0 rgba(0, 0, 0, 0.16)"
                      }}
                      href={invoice.invoicePDFUrl}
                      target="_blank"
                    >
                      <Icon type="download" />
                    </Button>
                  </Col>
                </Row>
              </StyledCol2>
            </>
          )}
        </Skeleton>
      </Row>
    </List.Item>
  );
};
